import { Component, OnInit, Inject, HostListener } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'trial-confirmation',
  templateUrl: './trial-confirmation.component.html',
  styleUrls: ['./trial-confirmation.component.scss']
})
export class TrialConfirmationComponent implements OnInit {

  document: Document;
  scrollPosition: number;
  fixHeaderAt: number;

  shouldShowSpinner : boolean;

  constructor(@Inject(DOCUMENT) document: Document) { 
    this.scrollPosition = 0;
    this.document = document;
    this.fixHeaderAt = 240;

  }

  ngOnInit() {
    this.fixHeaderAt = document.documentElement.clientWidth < 660 ? 360 : 240;
    this.scrollPosition = this.document.documentElement.scrollTop;
  }

  @HostListener("window:scroll", [])
  onWindowScroll() {
    this.scrollPosition = this.document.documentElement.scrollTop;
  }

  @HostListener("window:resize", [])
  onWindowResize() {
    this.fixHeaderAt = document.documentElement.clientWidth < 660 ? 360 : 240;
  }

}
